import {DEFAULT_LINE_PLOT_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {LinePlotDisplayFnArgs} from '../types';
import {LinePlotTemplateSettings} from '../workspaceTemplatesQueries';

export const getXLogScaleDisplayRow = ({
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
}: LinePlotDisplayFnArgs) => {
  const currTemplateXLogScale = currTemplateLinePlotSettings?.xLogScale;
  const newTemplateXLogScale = currWorkspaceLinePlotSettings?.xLogScale;

  return {
    label: 'X log scale',
    field: 'xLogScale' as keyof LinePlotTemplateSettings,
    currValue: currTemplateXLogScale,
    currDisplayValue:
      currTemplateXLogScale == null
        ? undefined
        : currTemplateXLogScale.toString(),
    newValue: newTemplateXLogScale ?? DEFAULT_LINE_PLOT_SETTINGS.xLogScale,
    newDisplayValue:
      newTemplateXLogScale == null
        ? DEFAULT_LINE_PLOT_SETTINGS.xLogScale.toString()
        : newTemplateXLogScale.toString(),
  };
};
